// ============================================================================
// Versión del bundle del FRONTEND, leída de `package.json` en build.
//
// Vite inlinea el valor en el bundle (import estático), sin lectura en
// runtime ni llamada de red. El auto-bump del pre-commit sube esta versión
// en cada commit, de modo que refleja el build desplegado del frontend.
// Mismo patrón que front_autohub (`shared/config/appVersion.js`).
// ============================================================================
import packageJson from "../../../package.json";

/** Versión semver del frontend (p. ej. "2.0.74"). */
export const FRONT_VERSION: string = packageJson.version;
